/* eslint-disable import/no-duplicates */
import logoMusic1 from '../../img/ImgLogoMusic/Screenshot 2022-06-04 at 20.05 (4).png';
import logoMusic2 from '../../img/ImgLogoMusic/Screenshot 2022-06-04 at 20.05 (5).png';
import logoMusic3 from '../../img/ImgLogoMusic/Screenshot 2022-06-04 at 20.05 (6).png';
import logoMusic4 from '../../img/ImgLogoMusic/Frame 41.png';
import logoMusic5 from '../../img/ImgLogoMusic/Screenshot 2022-06-04 at 20.05 (7).png';
import logoMusic6 from '../../img/ImgLogoMusic/Frame 41 (1).png';
import logoMusic7 from '../../img/ImgLogoMusic/Screenshot 2022-06-04 at 20.05 (8).png';
import logoMusic8 from '../../img/ImgLogoMusic/Screenshot 2022-06-04 at 20.05 (5).png';
import logoMusic9 from '../../img/ImgLogoMusic/Frame 41 (2).png';
import logoMusic10 from '../../img/ImgLogoMusic/Frame 41 (3).png';

export const itemsMusic = [
  {
    id: 1,
    img: logoMusic1,
    title: 'Play It Safe',
    name: 'Julia Wolf',
    album: 'Play It Safe',
    date_added: '...',
    liked: true,
    time: '2:12',
  },
  {
    id: 2,
    img: logoMusic2,
    title: 'Ocean Front Apt.',
    name: 'ayokay',
    album: 'In the Shape of a Dream',
    date_added: '...',
    liked: false,
    time: '2:12',
  },
  {
    id: 3,
    img: logoMusic3,
    title: 'Free Spirit',
    name: 'Khalid',
    album: 'Free Spirit',
    date_added: '...',
    liked: true,
    time: '3:02',
  },
  {
    id: 4,
    img: logoMusic4,
    title: 'Remind You',
    name: 'FRENSHIP',
    album: 'Vacation',
    date_added: '...',
    liked: false,
    time: '4:25',
  },
  {
    id: 5,
    img: logoMusic5,
    title: 'Same Old',
    name: 'SHY Martin',
    album: 'Same Old',
    date_added: '...',
    liked: false,
    time: '2:56',
  },
  {
    id: 6,
    img: logoMusic6,
    title: 'A Moment Apart',
    name: 'ODESZA',
    album: 'A Moment Apart',
    date_added: '...',
    liked: false,
    time: '3:54',
  },
  {
    id: 7,
    img: logoMusic7,
    title: 'Run Away',
    name: 'Manilla Killa, outsideOUT...',
    album: '1993',
    date_added: '...',
    liked: true,
    time: '3:13',
  },
  {
    id: 8,
    img: logoMusic8,
    title: 'Sleepless Nights (fea...',
    name: 'ayokay, Nightly',
    album: 'In the Shape of a Dream',
    date_added: '...',
    liked: true,
    time: '2:12',
  },
  {
    id: 9,
    img: logoMusic9,
    title: 'Wrong Kind Of People',
    name: 'Baker Grace',
    album: 'Girl, I Know',
    date_added: '...',
    liked: true,
    time: '3:14',
  },
  {
    id: 10,
    img: logoMusic10,
    title: 'Slow Grenade',
    name: 'Ellie Goulding, Lauv',
    album: 'Brightest Blue',
    date_added: '...',
    liked: false,
    time: '3:37',
  },
  {
    id: 11,
    img: logoMusic1,
    title: 'Play It Safe',
    name: 'Julia Wolf',
    album: 'Play It Safe',
    date_added: '...',
    liked: true,
    time: '2:12',
  },
  {
    id: 12,
    img: logoMusic2,
    title: 'Ocean Front Apt.',
    name: 'ayokay',
    album: 'In the Shape of a Dream',
    date_added: '...',
    liked: false,
    time: '2:12',
  },
  {
    id: 13,
    img: logoMusic3,
    title: 'Free Spirit',
    name: 'Khalid',
    album: 'Free Spirit',
    date_added: '...',
    liked: true,
    time: '3:02',
  },
  {
    id: 14,
    img: logoMusic4,
    title: 'Remind You',
    name: 'FRENSHIP',
    album: 'Vacation',
    date_added: '...',
    liked: true,
    time: '4:25',
  },
  {
    id: 15,
    img: logoMusic5,
    title: 'Same Old',
    name: 'SHY Martin',
    album: 'Same Old',
    date_added: '...',
    liked: false,
    time: '2:56',
  },
  {
    id: 16,
    img: logoMusic6,
    title: 'A Moment Apart',
    name: 'ODESZA',
    album: 'A Moment Apart',
    date_added: '...',
    liked: true,
    time: '3:54',
  },
  {
    id: 17,
    img: logoMusic7,
    title: 'Run Away',
    name: 'Manilla Killa, outsideOUT...',
    album: '1993',
    date_added: '...',
    liked: false,
    time: '3:13',
  },
  {
    id: 18,
    img: logoMusic8,
    title: 'Sleepless Nights (fea...',
    name: 'ayokay, Nightly',
    album: 'In the Shape of a Dream',
    date_added: '...',
    liked: false,
    time: '2:12',
  },
  {
    id: 19,
    img: logoMusic9,
    title: 'Wrong Kind Of People',
    name: 'Baker Grace',
    album: 'Girl, I Know',
    date_added: '...',
    liked: true,
    time: '3:14',
  },
  {
    id: 20,
    img: logoMusic10,
    title: 'Slow Grenade',
    name: 'Ellie Goulding, Lauv',
    album: 'Brightest Blue',
    date_added: '...',
    liked: true,
    time: '3:37',
  },
  {
    id: 21,
    img: logoMusic1,
    title: 'Play It Safe',
    name: 'Julia Wolf',
    album: 'Play It Safe',
    date_added: '...',
    liked: false,
    time: '2:12',
  },
  {
    id: 22,
    img: logoMusic2,
    title: 'Ocean Front Apt.',
    name: 'ayokay',
    album: 'In the Shape of a Dream',
    date_added: '...',
    liked: true,
    time: '2:12',
  },
  {
    id: 23,
    img: logoMusic3,
    title: 'Free Spirit',
    name: 'Khalid',
    album: 'Free Spirit',
    date_added: '...',
    liked: false,
    time: '3:02',
  },
  {
    id: 24,
    img: logoMusic4,
    title: 'Remind You',
    name: 'FRENSHIP',
    album: 'Vacation',
    date_added: '...',
    liked: false,
    time: '4:25',
  },
  {
    id: 25,
    img: logoMusic5,
    title: 'Same Old',
    name: 'SHY Martin',
    album: 'Same Old',
    date_added: '...',
    liked: true,
    time: '2:56',
  },
  {
    id: 26,
    img: logoMusic6,
    title: 'A Moment Apart',
    name: 'ODESZA',
    album: 'A Moment Apart',
    date_added: '...',
    liked: false,
    time: '3:54',
  },
  {
    id: 27,
    img: logoMusic7,
    title: 'Run Away',
    name: 'Manilla Killa, outsideOUT...',
    album: '1993',
    date_added: '...',
    liked: true,
    time: '3:13',
  },
  {
    id: 28,
    img: logoMusic8,
    title: 'Sleepless Nights (fea...',
    name: 'ayokay, Nightly',
    album: 'In the Shape of a Dream',
    date_added: '...',
    liked: false,
    time: '2:12',
  },
  {
    id: 29,
    img: logoMusic9,
    title: 'Wrong Kind Of People',
    name: 'Baker Grace',
    album: 'Girl, I Know',
    date_added: '...',
    liked: false,
    time: '3:14',
  },
  {
    id: 30,
    img: logoMusic10,
    title: 'Slow Grenade',
    name: 'Ellie Goulding, Lauv',
    album: 'Brightest Blue',
    date_added: '...',
    liked: true,
    time: '3:37',
  },
  {
    id: 31,
    img: logoMusic1,
    title: 'Play It Safe',
    name: 'Julia Wolf',
    album: 'Play It Safe',
    date_added: '...',
    liked: false,
    time: '2:12',
  },
  {
    id: 32,
    img: logoMusic2,
    title: 'Ocean Front Apt.',
    name: 'ayokay',
    album: 'In the Shape of a Dream',
    date_added: '...',
    liked: true,
    time: '2:12',
  },
  {
    id: 33,
    img: logoMusic3,
    title: 'Free Spirit',
    name: 'Khalid',
    album: 'Free Spirit',
    date_added: '...',
    liked: false,
    time: '3:02',
  },
  {
    id: 34,
    img: logoMusic4,
    title: 'Remind You',
    name: 'FRENSHIP',
    album: 'Vacation',
    date_added: '...',
    liked: true,
    time: '4:25',
  },
];
